import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractDetailContainer from './ContractDetailContainer';
import Separator from '../../../core/layout/Separator';
import ReactivateContractFormContainer from './ReactivateContractFormContainer';
import ReactivateContractProductsModalContainer from './ReactivateContractProductsModalContainer';

const ReactivateContractFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Reactivate Contract',
        },
      ]}
    />
    <ContractDetailContainer contractId={props.params.contractId} showOpenBills />
    <Separator />
    <ReactivateContractFormContainer contractId={props.params.contractId} />
    <ReactivateContractProductsModalContainer />
  </>
);

export default ReactivateContractFormScene;
